import Link from 'found/Link';
import React from 'react';

import { dateRangeToTimeRange } from '../time';

/**
 * Renders the label a property's trade rule.
 * @param {string} propertyId the property's id.
 * @param {string} tradeRuleId the id of the trade rule at the property.
 * @param {string} label a label to use for the link.
 * @returns {React.ReactElement | null} - The rendered meter content property label.
 */
export const propertyTradeRuleLink = (propertyId, tradeRuleId, label) => {
  if (!propertyId || !tradeRuleId) {
    return null;
  }

  return (
    <Link to={`/properties/${propertyId}/trade-rules/${tradeRuleId}`}>{label}</Link>
  );
};

/**
 * Renders the label for portfolio's property members.
 * @param {object} portfolio the portfolio object.
 * @param {string} portfolio.uuid the portfolio's uuid.
 * @param {object} portfolio.timespan the portfolio's timespan.
 * @param {object} portfolio.timespan.start the portfolio's timespan start.
 * @param {object} portfolio.timespan.finish the portfolio's timespan finish.
 * @param {string} label a label to use for the link.
 * @returns {React.ReactElement | null} - The rendered portfolio's property members label.
 */
export const portfolioPropertiesLink = (portfolio, label) => {
  const { uuid, timespan } = portfolio || {};
  if (!uuid) {
    return null;
  }
  const pathname = `/portfolios/${uuid}/properties`;
  const query = {};

  if (timespan) {
    const { start: startTime, finish: finishTime } = dateRangeToTimeRange(
      timespan,
    );

    query.start = startTime.toISODate();
    query.finish = finishTime.minus({ days: 1 }).toISODate();
  }

  return (
    <Link to={{
      pathname,
      query,
    }}
    >
      {label}
    </Link>
  );
};

/**
 * Renders the label for portfolio's user members.
 * @param {object} portfolio the portfolio object.
 * @param {string} portfolio.uuid the portfolio's uuid.
 * @param {object} portfolio.timespan the portfolio's timespan.
 * @param {object} portfolio.timespan.start the portfolio's timespan start.
 * @param {object} portfolio.timespan.finish the portfolio's timespan finish.
 * @param {string} label a label to use for the link.
 * @returns {React.ReactElement | null} - The rendered portfolio's user members label.
 */
export const portfolioUsersLink = (portfolio, label) => {
  const { uuid, timespan } = portfolio || {};
  if (!uuid) {
    return null;
  }
  const pathname = `/portfolios/${uuid}/users`;
  const query = {};

  if (timespan) {
    const { start: startTime, finish: finishTime } = dateRangeToTimeRange(
      timespan,
    );

    query.start = startTime.toISODate();
    query.finish = finishTime.minus({ days: 1 }).toISODate();
  }

  return (
    <Link to={{
      pathname,
      query,
    }}
    >
      {label}
    </Link>
  );
};
